/*
 * App Libraries
 */
import { Chain, Environment, WINDOW_PROVIDERS } from '@dcsg-ngx-ecommerce/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { SiteDownComponent } from '@origin/components';
/*
 * App Environment
 */
import { chain } from '@core/chain';
/// TODO - Re-evaluate this import
import { environment } from '../environments';

@NgModule({
	declarations: [AppComponent, SiteDownComponent],
	imports: [
		AppRoutingModule,
		BrowserAnimationsModule,
		HmfButtonComponent
	],
	providers: [
		{ provide: Chain, useValue: chain || {} },
		{ provide: Environment, useValue: environment || {} },
		WINDOW_PROVIDERS
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
